<template>
  <div class="">
    {{ productName }}
  </div>
</template>

<script>
export default {
  name: "FormChooseProductInputAnswer",
  props: {
    answer: {}
  },
  data() {
    return {
      productName: ''
    }
  },
  methods: {
    parseObjectString(str) {
      return JSON.parse(
          str
              .trim()
              .replace(/(\d+)\s*:/g, '"$1":')
      );
    },
    async findAnswer() {
      let answer = this.answer.label
      answer = this.parseObjectString(answer);
      let req = await this.$store.dispatch("Product/getProductsWithIds", {products: [Object.keys(answer)[0]]});
      this.productName = req.data.data[0].name
    }
  },
  async mounted() {
    await this.findAnswer()
  }
}
</script>

<style scoped>

</style>